var map = {
	"./A.png": "453a",
	"./D.png": "2fc9",
	"./I.png": "8119",
	"./N.png": "3e7a",
	"./Name.png": "557b",
	"./P.png": "4d58",
	"./Password.png": "68dc",
	"./Phone.png": "449b",
	"./S.png": "9bc3",
	"./T.png": "eab6",
	"./Username.png": "62f1",
	"./chat1.png": "b2d7",
	"./chat2.png": "13cf",
	"./contacts1.png": "7dd1",
	"./contacts2.png": "4be7",
	"./home1.png": "1a27",
	"./home2.png": "a415",
	"./oils1.png": "6cc7",
	"./oils2.png": "52c5",
	"./recipes1.png": "1b0e",
	"./recipes2.png": "6243"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61b0";